export const siteConfig = {
    pages: {
        home: '/',
        paymentWorkspace: '/payment/workspace',
        paymentWorkspaceSummary: '/payment/workspace/summary',
        paymentFree: '/payment/free',
        paymentEnterprise: '/payment/enterprise',
        paymentEnterpriseSummary: '/payment/enterprise/summary',
        privacyPolicy: '/privacy-policy/',
        cookiePolicy: '/privacy-policy/#cookie-policy',
        termsAndConditions: '/terms-and-conditions/',
        refundPolicy: '/docs/billing/refund-policy/',
        faq: '/faq/',
        faqSecurity: '/faq/security/',
        faqRecords: '/faq/records/',
        faqUsers: '/faq/users/',
        faqFeatures: '/faq/features/',
        faqPayment: '/faq/payment/',
        haveIBeenPwned: '/hack-checker',
        customerStories: {
            acalvio: '/customer-stories/acalvio/',
            ajir: '/customer-stories/ajir/',
            cartken: '/customer-stories/cartken/',
            pixelfield: '/customer-stories/pixelfield/',
            fishtank: '/customer-stories/fishtank/',
            ackeeBlockchain: '/customer-stories/ackee-blockchain/',
            audiochuck: '/customer-stories/audiochuck/',
            digitalAnt: '/customer-stories/digital-ant/',
            redHawk: '/customer-stories/red-hawk/',
            erikasLighthouse: '/customer-stories/erikas-lighthouse/',
            soupAgency: '/customer-stories/soup-agency/',
            villaFinder: '/customer-stories/villa-finder/',
        },
    },
    landingPageSections: {
        overview: 'overview',
        features: 'features',
        pricing: 'pricing',
        contact: 'contact',
    },
    apiBase: '/api/v1',
    externalLinks: {
        demo: 'https://demo.passwd.team/',
        googleWorkspaceMarketplace:
            'https://workspace.google.com/marketplace/app/passwd_password_manager_for_google_works/820025595231',
        trustpilot: 'https://www.trustpilot.com/review/passwd.team',
        g2: 'https://www.g2.com/products/passwd-team-password-manager/reviews?utm_source=rewards-badge',
        docs: '/docs',
        blog: '/blog',
        passwdApp: 'https://app.passwd.team',
    },
    footerLinks: {
        linkedin: 'https://www.linkedin.com/company/passwd.team/',
        bugs: 'https://passwd.team/blog/passwd-bug-bounty-program/',
        czMap: 'https://goo.gl/maps/Dr5Xk6Dn16P5hfam6',
        usMap: 'https://maps.app.goo.gl/47U3B6gwjxzbcK1W7',
    },
    gtmId: 'GTM-WPQZK5N',
    socialIntentsScriptUrl:
        'https://www.socialintents.com/api/chat/socialintents.1.4.js#2c9fab3f9df0a5b8019dfda8d373108f',
    typekitCss: 'https://use.typekit.net/jli4xio.css',
} as const;
